import { render, staticRenderFns } from "./MemberManagement.vue?vue&type=template&id=8b47689e&"
import script from "./MemberManagement.vue?vue&type=script&lang=ts&"
export * from "./MemberManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports